import React from 'react';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';

class SMSearchListSortView extends React.Component {

  constructor(props) {
    super(props);
  }

  selectBoxDidChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.sortDidChangeValue === 'function'){
      this.props.delegate.sortDidChangeValue(e.currentTarget.value);
    }
  }

  render() {

    let sortItems = [
      {label: "おすすめ順", value: "popular"},
      {label: "価格が安い順", value: "price"},
      {label: "収容人数順", value: "capacity"},
      {label: "新着順", value: "created"},
    ];

    return(
      <SMFormSelectBox
        name="sort"
        delegate={this}
        items={sortItems}
        selectedValue={this.props.selectedValue}
        options={{className: "service-select__sort"}}
        />
    );
  }
}

export default SMSearchListSortView;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchListSortView.jsx